<template lang="pug">
form#field-options-form(@submit.prevent="submit")
  .modal-card
    header.modal-card-head
      p.modal-card-title Field Options
    section.modal-card-body
      div(v-if="field.type === 'number'")
        b-field(label="Minimum")
          b-input(
            type="number"
            :value="field.min"
            @input="set($event, 'min')"
          )
        b-field(label="Maximum")
          b-input(
            type="number"
            :value="field.max"
            @input="set($event, 'max')"
          )
      div(v-else-if="field.type === 'select'")
        b-field(label="Display As")
          b-select(
            :value="field.select_type"
            @input="set($event, 'select_type')"
          )
            option(value="select") Dropdown
            option(value="check") Checkboxes
      div(v-else-if="field.type === 'textarea'")
        b-field(label="Rows")
          b-input(
            type="number"
            :value="field.rows"
            @input="set($event, 'rows')"
          )
      div(v-else-if="field.type === 'waiver'")
        b-field(label="Waiver")
          b-select(
            :value="field.waiver_id"
            @input="set($event, 'waiver_id')"
          )
            option(
              v-for="waiver in waivers"
              :key="waiver.id"
              :value="waiver.id"
            ) {{ waiver.name }}
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save Field
</template>

<script>
import { mapGetters } from 'vuex';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'field-options-form',
  computed: {
    ...mapGetters({
      field: getters.GET_FORM_FIELD,
      waivers: getters.GET_WAIVERS,
    }),
  },
  async created() {
    if (this.field.type === 'waiver') {
      await this.$store.dispatch(actions.DO_GET_WAIVERS, {});
    }
  },
  data() {
    return {
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_FORM_FIELD_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      this.settings.submitting = true;
      const response = await this.$store.dispatch(actions.DO_UPDATE_FORM_FIELD, {
        id: this.field.id,
        max: this.field.max,
        min: this.field.min,
        rows: this.field.rows,
        select_type: this.field.select_type,
        waiver_id: this.field.waiver_id,
      });
      this.$parent.close();
      this.settings.submitting = false;
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/FieldOptionsForm.vue